import "./HomePage.css";

import logo from "../assets/logos/stackrize-logo.svg";

import starIcon from "../assets/icons/star.svg";
import sparkLines from "../assets/icons/spark-lines.svg";
import waveArrow from "../assets/icons/arrow.svg";
import handIcon from "../assets/icons/crown.svg";
import A from "../assets/icons/stackraize.svg";
import leftLight from "../assets/icons/left-light.svg";
import centerLight from "../assets/icons/center-light.svg";
import rightLight from "../assets/icons/right-light.svg";
import wavearrow from "../assets/icons/wave-arrow.svg";
import sectionIcon from "../assets/icons/course-title.svg";
import courseIcon from "../assets/icons/card-icon.svg";
import cardFold from "../assets/icons/card-fold.svg"
import heartIcon from "../assets/icons/heart-dynamic-color.svg"
import curveLines from "../assets/icons/curve-lines.svg";
import certificateImage from "../assets/images/certificate.png";
import certificateLeftGlow from "../assets/icons/certificate-left-glow.svg";
import certificateRightGlow from "../assets/icons/certificate-right-glow.svg";
import whatsappIcon from "../assets/icons/whatsapp.svg";
import whatsappIcon1 from "../assets/icons/whatsapp-icon.svg";
import leftPath from "../assets/icons/left-path.svg";
import rightPath from "../assets/icons/right-path.svg";
import questionIcon from "../assets/icons/question.svg";
import { useState,useEffect, useRef } from "react";
import { courses } from "../components/Courses";
import { Link } from "react-router-dom";

import footerRightLogo from "../assets/logos/footer-right-logo.svg";
import footerLeftLogo from "../assets/logos/footer-left-logo.svg";

import footerEffect from "../assets/icons/footer-effect.svg";

import instagramIcon from "../assets/icons/instagram-icon.svg";
import facebookIcon from "../assets/icons/facebook-icon.svg";
import emailIcon from "../assets/icons/email-icon.svg";
import twitterIcon from "../assets/icons/twitter-icon.svg";

import frontendIcon from "../assets/icons/front-icon.svg";
import flutterIcon from "../assets/icons/course-flutter.svg";
import backendAsp from "../assets/icons/backend-aspsvg.svg";
import backendLaravel from "../assets/icons/backend-laravel.svg";
import uiuxIcon from "../assets/icons/uiux-icon.svg";

import craficateIcon from "../assets/icons/Certificate.svg";
import craficateIcon1 from "../assets/icons/cratificate-icon.svg";
import portofolioIcon from "../assets/icons/portfolio.svg";
import marketIcon from "../assets/icons/market-job.svg";
import learnIcon from "../assets/icons/new-learn.svg";
import projectsIcon from "../assets/icons/projects.svg";
import experiansIcon from "../assets/icons/experians.svg";



export default function HomePage() {

const [menuOpen, setMenuOpen] = useState(false);
const features1 = [
  "شهادات إتمام معتمدة",
  "مشاريع حقيقية للسيرة الذاتية",
  "دعم وإرشاد مباشر",
  "تأهيل لسوق العمل",
  "مدربون بخبرة عملية",
  "تدريب أونلاين بالكامل",
];

const features2 = [
  "جلسات مباشرة",
  "مدربون بخبرة عملية",
  "شهادة معتمدة",
  "دعم بعد انتهاء الدورة",
  "مشاريع احترافية",
  "تأهيل لسوق العمل",
];

const [track, setTrack] = useState(0);

const handleAnimationEnd = () => {
  setTrack((prev) => (prev === 0 ? 1 : 0));
};
useEffect(() => {
  const interval = setInterval(() => {
    setTrack((prev) => (prev === 0 ? 1 : 0));
  }, 14000); // نفس مدة الأنيميشن

  return () => clearInterval(interval);
}, []);
const faqs = [
  {
    question: "كيف يمكنني التسجيل في الكورسات؟",
    answer:
      "يمكنك التسجيل بسهولة من خلال اختيار الدورة المناسبة ثم إتمام عملية التسجيل والدفع، وسيتم تفعيل وصولك إلى الدورة مباشرة.",
  },
  {
    question: "هل أحتاج إلى خبرة سابقة قبل بدء الدورة؟",
    answer:
      "لا، جميع دوراتنا تبدأ معك من الصفر ثم تتدرج حتى المستوى الاحترافي.",
  },
  {
    question: "هل أحصل على شهادة بعد إكمال الكورس؟",
    answer:
      "نعم، تحصل على شهادة إتمام معتمدة بعد إنهاء الدورة بنجاح.",
  },
  {
    question: "هل الدورات أونلاين أم حضورية؟",
    answer:
      "جميع الدورات أونلاين ويمكنك حضورها من أي مكان وفي أي وقت.",
  },
  {
    question: "هل ستساعدوني بالتوظيف؟",
    answer:
      "نساعدك ببناء معرض أعمال احترافي وتحضيرك للمقابلات وتوجيهك لسوق العمل.",
  },
  {
    question: "هل يمكنني التواصل مع المدرب عند وجود سؤال؟",
    answer:
      "بالتأكيد، يوجد دعم مباشر وإمكانية التواصل مع المدرب طوال فترة الدورة.",
  },
];

const [activeFaq, setActiveFaq] = useState(null);

// إذا بدك أول عنصر مفتوح افتراضياً خليه 0
// وإذا بدك كلهن مغلقين بالبداية خليه null
const journeyData = [
  {
    id: 1,
    title: "شهادة معتدمة :  ",
    description:" شهادة صادرة من شريكنا التعليمي المرخص في المملكة المتحدة .",
    image: craficateIcon,
    
  },
  {
    id: 2,
    title: "معرض أعمال (Portfolio)",
    description: "معرض أعمال احترافي يثبت مهاراتك أمام أصحاب العمل والعملاء.",
    image: portofolioIcon,
  },
  {
    id: 3,
    title: "تأهيل لسوق العمل",
    description: "تأهيل حقيقي لسوق العمل وفق متطلبات الشركات الحديثة.",
    image: marketIcon,
  },
  {
    id: 4,
    title: "مناهج حديثة",
    description: "مناهج حديثة مواكبة لمتطلبات سوق العمل.",
    image: learnIcon,
  },
  {
    id: 5,
    title: "مشاريع عملية",
    description: "مشاريع عملية واقعية تبني من خلالها خبرتك.",
    image: projectsIcon,
  },
  {
    id: 6,
    title: "تعلم من خبراء",
    description: "استفد من خبرات المدربين وتعرّف على أفضل الممارسات والأدوات .",
    image: experiansIcon,
  },
];
  useEffect(() => {
  if (window.location.hash) {
    const id = window.location.hash.substring(1);

    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  }
}, []);
  useEffect(() => {
  if (menuOpen) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }

  return () => {
    document.body.style.overflow = "";
  };
}, [menuOpen]);
const scrollToSection = (id) => {
  document.getElementById(id)?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });


  setMenuOpen(false); // لإغلاق قائمة الموبايل
};
  return (
    <>
    <section className="home-hero" id="hero">

      <div className="hero-frame">

      {/* Glows */}

      <img src={leftLight} className="bg-light left-light" alt="" />
      <div className="lights-overlay"></div>

<img src={centerLight} className="bg-light center-light" alt="" />
<img src={rightLight} className="bg-light right-light" alt="" />

      {/* Noise */}

      <div className="home-noise"></div>

      {/* Curves */}

      <div className="home-curve home-left-curve"></div>
      <div className="home-curve home-right-curve"></div>
{/* Paths */}
<img src={leftPath} alt="" className="hero-path left-path" />
<img src={rightPath} alt="" className="hero-path right-path" />

      {/* Floating Tags */}

      <div className="home-tag-wrapper home-ui">

    <img
        src={waveArrow}
        alt=""
        className="tag-arrow right-arrow"
    />

    <div className="home-tag">
        UI Designer
    </div>

</div>

      <div className="home-tag-wrapper home-mobile">

    

    <div className="home-tag">
        M-App
    </div>
    <img
        src={waveArrow}
        alt=""
        className="tag-arrow right-arrow"
    />

</div>

      <div className="home-tag-wrapper home-front">

    <img
        src={waveArrow}
        alt=""
        className="tag-arrow left-arrow"
    />

    <div className="home-tag">
        Front End
    </div>

</div>
       

      <div className="home-tag-wrapper home-back">

    <img
        src={waveArrow}
        alt=""
        className="tag-arrow left-arrow"
    />

    <div className="home-tag">
        Back End
    </div>

</div>

      {/* Navbar */}

                    <nav className="home-navbar">
<div
  className="mobile-menu"
  onClick={() => setMenuOpen(!menuOpen)}
>
  {menuOpen ? "✕" : "☰"}
</div>
<div className="navbar-social">



                <a href="https://www.instagram.com/skillrize2026?igsh=MWdsaXZlcmUzMHdydQ=="  target="_blank"
  rel="noreferrer"> 

                    <img
                        src={instagramIcon}
                        alt=""
                    />

                </a>

            <a href="https://www.facebook.com/share/1H2xWPDneh/"  target="_blank"
  rel="noreferrer">

                    <img
                        src={facebookIcon}
                        alt=""
                    />

                </a>

                <a href="https://wa.me/963982749102 "  target="_blank"
  rel="noreferrer">

                    <img
                        src={whatsappIcon1}
                        alt=""
                    />

                </a>

            </div>
        

        <ul className="home-links ">
         <Link to="/">
          <li  >
            الرئيسية
          </li>
          </Link>

         <li onClick={() => scrollToSection("courses")}>المسارات</li>

<li onClick={() => scrollToSection("career")}>من نحن</li>

<li onClick={() => scrollToSection("journey")}>الخدمات</li>


  <a href="https://wa.me/963982749102 "  target="_blank"
  rel="noreferrer"><li>اتصل بنا</li></a>

        </ul>

       <div className="home-brand">

          

          <div className="brand-text">

            <img src={A}/>


          </div>

        </div>
      </nav>
      {menuOpen && (
  <div
    className="mobile-overlay"
    onClick={() => setMenuOpen(false)}
  ></div>
)}
      {menuOpen && (
  <div className="mobile-nav">

    <Link className="active" to="/" onClick={() => setMenuOpen(false)}>
      الرئيسية
    </Link>

    <a
  href="#"
  onClick={(e) => {
    e.preventDefault();
    scrollToSection("courses");
  }}
>
  المسارات
</a>

<a
  href="#"
  onClick={(e) => {
    e.preventDefault();
    scrollToSection("career");
  }}
>
  من نحن
</a>

<a
  href="#"
  onClick={(e) => {
    e.preventDefault();
    scrollToSection("journey");
  }}
>
  الخدمات
</a>

  <a href="https://wa.me/963982749102 "  target="_blank"
  rel="noreferrer"><li>اتصل بنا</li></a>

    <div className="mobile-social">

                      <a href="https://www.instagram.com/skillrize2026?igsh=MWdsaXZlcmUzMHdydQ=="  target="_blank"
  rel="noreferrer">        <img src={instagramIcon} alt="" />
      </a>

      <a href="https://www.facebook.com/share/1H2xWPDneh/"  target="_blank"
  rel="noreferrer">
        <img src={facebookIcon} alt="" />
      </a>

                      <a href="https://wa.me/963982749102 "  target="_blank"
  rel="noreferrer">

                    <img
                        src={whatsappIcon1}
                        alt=""
                    />

                </a>

    </div>

  </div>
)}

      {/* Content */}

      <div className="home-content">

        <div className="home-badge">


       
            <span className="hello">👋</span>
               <span>
              مرحباً بك في ستاك رايز   
          </span>


        </div>

        <div className="title-wrapper">

          

          <h1>

            لا نجهزك للامتحان...<img
            src={sparkLines}
            alt=""
            className="title-spark"
          />
            <br />

            نجهزك للمقابلة الوظيفية الأولى.

          </h1>
         

        </div>

        <p>

          هناك فرق بين شخص يشاهد الدروس...

          <br />

          وشخص يبني مستقبله، نأخذك من نقطة الصفر إلى مستوى احترافي يؤهلك للمنافسة في سوق العمل الحقيقي.

        </p>

        <div className="home-buttons">

    <div className="training-btn-wrapper">
    <a
  href="#"
  onClick={(e) => {
    e.preventDefault();
    scrollToSection("courses");
  }}
>
        <button className="home-primary-btn">
            مساراتنا التدريبية
        </button>
        </a>

        <img
            src={wavearrow}
            alt=""
            className="training-arrow"
        />

    </div>
  <a href="https://wa.me/963982749102 "  target="_blank"
  rel="noreferrer">
    <button className="home-secondary-btn">
        اتصل بنا
    </button>
    </a>
    

</div>
<div className="home-bottom-section">

  <span className="future-text">
    نحو مستقبل مهني أقوى!
  </span>

<div className="features-wrapper">
<div className="features-mask">
  <div
    key={track}
    className="features-track"
    onAnimationEnd={handleAnimationEnd}
  >
    {(track === 0 ? features1 : features2).map((item, i) => (
      <div className="feature-pill" key={i}>
        {item}
      </div>
    ))}
  </div>
</div>

</div>

</div>

      </div>
</div>


    </section>
    <section className="courses-section1" id="courses">

  <div className="courses-title1">

    <img src={sectionIcon} alt="" />

    <h2>المسارات التي نقدمها :</h2>

  </div>

  <div className="courses-grid1">

{courses.map((course, index) => (
  <div
    key={index}
    className={`course-card1 ${index > 2 ? "wide-card1" : ""}`}
  >
    <img src={cardFold} alt="" className="card-fold1" />

    <div className="card-icon1">
      <img src={course.icon} alt={course.title} />
    </div>

    <h3>{course.title}</h3>

    <p>{course.description1}</p>

    <div className="course-footer1">
      <div className="course-price1">
        <span className="old-price1">
          {Number(course.price.replace("$", "")) + 40}$
        </span>

        <span className="new-price1">
          {course.price}
        </span>
      </div>

      <Link
  to={`/courses/${course.slug}`}
  onClick={() => window.scrollTo(0, 0)}
>
  <button>تفاصيل الكورس</button>
</Link>
    </div>
  </div>
))}
  </div>

</section>
<section className="journey-section "id="journey">

 <div className="journey-title">

    <span className="journey-line"></span>

    <span className="journey-badge">
        <img src={heartIcon}  alt="" className="journey-heart"/>
        ماذا سيحصل الطالب
    </span>

    <span className="journey-line left"></span>

</div>

  <div className="journey-grid">

    {journeyData.map((item) => (
  <div key={item.id} className="journey-card">
    <div className={`journey-icon `}>
      <img src={item.image} alt={item.title} />
      
    </div>

    <div className="journey-content">
      <h3>{item.title}</h3>
      <p>{item.description}</p>
    </div>
  </div>
))}

  </div>

</section>
<section className="career-section" id="career">

  <div className="career-left">

    <img
      src={curveLines}
      alt=""
      className="career-lines"
    />

    <div className="career-particles"></div>

    <div className="dream dream-1">
      حلم بدون طريق
    </div>

    <div className="dream dream-2">
      حلم بدون طريق
    </div>

    <div className="dream dream-3">
      حلم بدون طريق
    </div>

    <div className="dream dream-4">
      حلم بدون طريق
    </div>

    <div className="dream dream-5">
      حلم بدون طريق
    </div>

    <div className="dream dream-6">
      حلم بدون طريق
    </div>

    <div className="goal-card">

      <h3>
        نبني مهارات تقودك
        <br />
        لسوق العمل
      </h3>

    </div>

  </div>



  <div className="career-right">

    <div className="career-badge">

      <span className="badge-dot"></span>

      من نحن في StackRize

    </div>

    <h2>

      

            
            نبني جيلاً تقنياً     <span className="spark">✨</span>   
      <br />

      جاهزاً للنجاح في سوق العمل.

    </h2>

    <p>
StackRize Academy هي أكاديمية تقنية متخصصة في تأهيل المبرمجين والمصممين لسوق العمل من خلال مسارات تدريبية عملية، مشاريع واقعية، وإشراف مباشر من خبراء المجال، بهدف تحويل ا لمتدرب من مبتدئ إلى محترف قادر على بناء حلول رقمية حقيقية

    </p>

    <div className="career-tags">

      <div className="career-tag green">
       نتعلم
      </div>

      <div className="career-tag blue">
       ننجح
      </div>

      <div className="career-tag orange">
       نبدع
      </div>

    </div>

  </div>

</section>
<section className="certificate-section" id="certificate">

  <img
    src={certificateLeftGlow}
    alt=""
    className="certificate-glow left"
  />

  <img
    src={certificateRightGlow}
    alt=""
    className="certificate-glow right"
  />

  <div className="certificate-header">

    <span className="certificate-line"></span>

    <span className="certificate-badge">
      
     
      الشهادة المعتمدة
      <img src={craficateIcon1} alt="" />
    </span>

    <span className="certificate-line"></span>

  </div>

  <h2>
شهادة احترافية تثبت    <span>  مهاراتك</span>
  </h2>

  <p>
   يحصل كل متدرب بعد إتمام البرنامج واجتياز متطلباته على شهادة إتمام رسمية صادرة من SkillRize Academy، توثق المهارات العملية والمشاريع التي أنجزها خلال البرنامج التدريبي.
  </p>

  <div className="certificate-card">

    <div className="certificate-inner">

      <img
        src={certificateImage}
        alt="Certificate"
      />

    </div>

  </div>

</section>
<section className="whatsapp-section">

  <div className="whatsapp-divider"></div>

  <h2>
    لو عندك أي استفسار، تقدر تكلمنا على واتساب مباشرة من هنا
  </h2>

  <div className="whatsapp-arrow">
    👇
  </div>

  <a
  href="https://wa.me/963982749102"
  target="_blank"
  rel="noreferrer"
  className="whatsapp-btn"
>
  <img src={whatsappIcon} alt="" className="whatsapp-icon" />
  <span>واتس اب</span>
</a>

</section>
<section className="faq-section" id="faq">

    <div className="faq-title">

        <span className="faq-line"></span>

        <div className="faq-heading">
            <h2>الأسئلة الشائعة</h2>


            <img src={questionIcon} alt="" />


        </div>

        <span className="faq-line"></span>

    </div>

    <div className="faq-container">

        {faqs.map((faq, index) => {

            const active = activeFaq === index;

            return (

                <div
                    key={index}
                    className={`faq-card ${active ? "active" : ""}`}
                >

                    <div
                        className="faq-header"
                        onClick={() =>
    setActiveFaq(activeFaq === index ? null : index)
}
                    >

                        <div className="faq-icon">

                            {active ? "×" : "+"}

                        </div>

                        <div className="faq-question">

                            <h3>{faq.question}</h3>

                        </div>

                        <div className="faq-number">

                            {(index + 1)
                                .toString()
                                .padStart(2, "0")}

                        </div>

                    </div>

                    <div
                        className={`faq-answer ${
                            active ? "show" : ""
                        }`}
                    >

                        <p>{faq.answer}</p>

                    </div>

                </div>

            );
        })}
    </div>

</section>
<section className="footer-section">

    <img
        src={footerLeftLogo}
        alt=""
        className="footer-side-logo left"
    />

    <img
        src={footerRightLogo}
        alt=""
        className="footer-side-logo right"
    />

    <img
        src={footerEffect}
        alt=""
        className="footer-effect"
    />

    <div className="footer-content">

        <h2>

           .كل خبير كان مبتدئاً يوماً... ابدأ رحلتك معنا

        </h2>

        <p>

           ،نؤمن أن التعلم هو بداية كل نجاح 

            <br />

           .ونسعى لتقديم تجربة تعليمية عملية تُمهّد طريقك نحو مستقبل مهني أفضل

        </p>
  <a href="https://wa.me/963982749102 "  target="_blank"
  rel="noreferrer">        <button className="footer-btn">

           تواصل معنا

        </button>
        </a>

        <div className="footer-divider"></div>

        <div className="footer-bottom">

            <div className="home-brand">
              

                <div className="brand-text">

                    <span>

                        <img src={A} alt="" />

                    </span>

                    

                </div>

                

            </div>

            <ul className="footer-links">

                

                <li onClick={() => scrollToSection("faq")}>الأسئلة الشائعة</li>

                <li onClick={() => scrollToSection("certificate")}>الشهادة</li>

                <li onClick={() => scrollToSection("courses")}>المسارات</li>

<li onClick={() => scrollToSection("career")}>من نحن</li>

                <li onClick={() => scrollToSection("hero")}>الرئيسية</li>

            </ul>

            <div className="footer-social">

                

                <a href="https://wa.me/963982749102 "  target="_blank"
  rel="noreferrer">

                    <img
                        src={whatsappIcon1}
                        alt=""
                    />

                </a>
            <a href="https://www.facebook.com/share/1H2xWPDneh/"  target="_blank"
  rel="noreferrer">

                    <img
                        src={facebookIcon}
                        alt=""
                    />

                </a>
                <a href="https://www.instagram.com/skillrize2026?igsh=MWdsaXZlcmUzMHdydQ=="  target="_blank"
  rel="noreferrer"> 

                    <img
                        src={instagramIcon}
                        alt=""
                    />

                </a>



            </div>

        </div>

    </div>

</section>
</>
    
  );
}